/** app constants */

export const PASSWORD_CONFIRMATION_HINT_TEXT = 'Should match the password'
export const MINIMUM_PASSWORD_LENGTH = 8
export const PASSWORD_HINT_TEXT = `At least ${MINIMUM_PASSWORD_LENGTH} characters`
export const BROWSER_NOT_SUPPORTED_TEXT = 'Browser is not supported. Please open the page in Chrome 45+, Safari 11.1+, Opera 32+ on desktop'
